import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "item", "template", "add", "hex", "name"]

  connect() { this.refresh() }

  add() {
    if (this.itemTargets.length >= 16) return
    this.listTarget.append(this.templateTarget.content.cloneNode(true))
    this.refresh()
    this.itemTargets.at(-1).querySelector("input").focus()
  }

  remove(event) {
    if (this.itemTargets.length <= 2) return
    event.currentTarget.closest('[data-ui-palette-editor-target="item"]').remove()
    this.refresh()
  }

  up(event) {
    const item = event.currentTarget.closest('[data-ui-palette-editor-target="item"]')
    if (item.previousElementSibling) this.listTarget.insertBefore(item, item.previousElementSibling)
    this.refresh()
    event.currentTarget.focus()
  }

  down(event) {
    const item = event.currentTarget.closest('[data-ui-palette-editor-target="item"]')
    if (item.nextElementSibling) this.listTarget.insertBefore(item.nextElementSibling, item)
    this.refresh()
    event.currentTarget.focus()
  }

  updateSwatch(event) { this.paint(event.currentTarget) }

  paint(input) {
    const value = input.value.trim().replace(/^#/, "")
    const swatch = input.closest('[data-ui-palette-editor-target="item"]').querySelector("[data-ui-palette-editor-swatch]")
    swatch.style.backgroundColor = /^(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(value) ? `#${value}` : "transparent"
  }

  refresh() {
    const count = this.itemTargets.length
    this.addTarget.disabled = count >= 16
    this.itemTargets.forEach((item, index) => {
      const input = item.querySelector("input")
      const label = item.querySelector("[data-ui-palette-editor-label]")
      input.id = `palette_color_${index}`
      const name = item.querySelector('[data-ui-palette-editor-target="name"]')
      name.id = `palette_color_name_${index}`
      name.setAttribute("aria-label", `Color ${index + 1} name`)
      label.htmlFor = input.id
      label.textContent = `Color ${index + 1}`
      item.querySelector('[data-action="ui-palette-editor#up"]').disabled = index === 0
      item.querySelector('[data-action="ui-palette-editor#down"]').disabled = index === count - 1
      item.querySelector('[data-action="ui-palette-editor#remove"]').disabled = count <= 2
      this.paint(input)
    })
  }
}
